import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";

import { toast } from "react-toastify";
import SearchCreatable from "../../../ExpenseManagement/helper/HelperComponents/SearchCreatable";
import SelectableEditableFilter from "../../../Base/views/SelectableEditableFilter";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import { AddGoalSubtypeAction,
  AddGoalTypeAction,
  DeleteGoalSubtypeAction,
  DeleteGoalTypeAction,
  GetGoalSubtypeAction,
  GetGoalTypeAction,
  UpdateGoalSubtypeAction,
  UpdateGoalTypeAction, } from "../../../../../store/Employee/PMSSetting/Action";

const GoalCategoryGrid = () => {
  const dispatch = useDispatch();
  const { goal_types, goal_subtypes, goalSubtypeLoading } =
    useSelector((state) => state?.EmployeeReducer?.GoalReducer);

  const structureData = (goal_subtypes || [])?.map((item) => ({
    ...item,
    goal_category_configuration_pk: {
      goal_category_configuration_pk: item?.goal_category_fk,
      goal_category_name: item?.goal_category_name,
    },
    goal_subcategory: item?.goal_sub_category_name
    
  }));
  const [selected, setSelected] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [deletedItem, setDeletedItem] = useState({});

  const [categoryData, setCategoryData] = useState({
    load: true,
    values: [],
  });
  const handleGoalCategory = () => {
    goal_types && setCategoryData({ load: false, values: goal_types });
  };

  useEffect(() => {
    dispatch(GetGoalTypeAction());
  }, [dispatch]);

  const handleAddGoalType = (event, value) => { 
    return new Promise((resolve, reject) => {
      dispatch(
        AddGoalTypeAction(
          {
            goal_category: value?.goal_category_name,
          },
          (error, result) => {
            if (!error && result?.data?.statuscode === 200) {
              const newData = result?.data?.data;
              setCategoryData({ load: false, values: newData });

              const resVal = newData.find(
                (res) => res?.goal_category_name === value?.goal_category_name
              );
              resolve(resVal);
            } else {
              toast.error("Something went wrong");
              reject(error);
            }
          }
        )
      );
    });
  };
  useEffect(() => {
    if (goal_types?.length > 0) {
      setCategoryData({ load: false, values: goal_types });
    }
  }, [goal_types]);

  const handleEdit = (updatedItem) => {           
    dispatch(UpdateGoalTypeAction({
      goal_category_config_pk: updatedItem?.goal_category_configuration_pk,
      goal_category: updatedItem?.goal_category_name,
    }))
  };
  
  const handleDelete = (deletedItem) => {
    setOpenDialog(true);
    setDeletedItem(deletedItem)    
  };
  const handleSubmitDelete = () => {
    dispatch(
      DeleteGoalTypeAction({
        goal_category_config_pk: deletedItem?.goal_category_configuration_pk,
      },
        (error, result) => {
          if (!error && result?.data?.statuscode === 200) {
            if(selected?.goal_category_configuration_pk === deletedItem?.goal_category_configuration_pk) {
              setSelected("");
            }
            setOpenDialog(false);
            setDeletedItem({})
            const filterSubType = goal_subtypes?.filter((el => el.goal_category_fk === deletedItem?.goal_category_configuration_pk))
            if (filterSubType?.length > 0) {
              dispatch(
                       DeleteGoalSubtypeAction({
                         goal_subcategory_config_id: `{${filterSubType?.map(item => item.goal_sub_category_configuration_pk).join(",")}}`
                       })
                     );
            }
          } else {
            toast.dismiss();
            toast.error("Something went wrong");
          }
        }
      )
    );
  }
  useEffect(()=> {
    dispatch(GetGoalSubtypeAction({
      goal_category_id: selected?.goal_category_configuration_pk ? `{${selected?.goal_category_configuration_pk}}` : null 
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selected])
  const titleContent = <Box pt={1.5} pb={2} sx={{ minWidth: 250}}>
      <SelectableEditableFilter 
       label="Goal Category"
        optionData={goal_types}
        name={"goal_category_configuration_pk"}
        fieldLabel="goal_category_name"
        value={selected}
        onChange={(val) => setSelected(val)}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
  </Box>
return (
    <Box>
      <MaterialTable
        isLoading={goalSubtypeLoading}
        columns={[
          {
            title: "Goal Category",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "goal_category_configuration_pk",
            grouping: false,
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.goal_category_configuration_pk) {
                return "Goal Category cannot be empty";
              }
              return "";
            },
            render: (rowData) =>
              rowData?.goal_category_configuration_pk?.goal_category_name || "",
            editComponent: (props) => {
              const isEdit = props.rowData?.tableData?.editing === "update";
              return (
                <Box sx={{ width: "95%" }}>
                  <SearchCreatable
                    isOptionEqualToValue={(option, value) =>
                      +option.goal_category_configuration_pk === +value.goal_category_configuration_pk
                    }
                    fullWidth
                    disabled={isEdit}
                    required
                    variantType="standard"
                    size="small"
                    loading={() => handleGoalCategory()}
                    value={props.value || ""}
                    fieldLabel="goal_category_name"
                    name="goal_category_configuration_pk"
                    onChangeEvent={async (e, v) => {
                      if (v?.goal_category_configuration_pk) {
                        props.onChange(v);
                      } else if (v?.goal_category_name) {
                        const newExp = await handleAddGoalType(e, v);
                        props.onChange(newExp);
                      } else {
                        props.onChange(v);
                      }
                    }}
                    data={categoryData}
                    showAddOption={true}
                    OptionName="Type to add new Goal Category"
                  />
                </Box>
              );
            },
          },
          {
            title: "Goal",
            cellStyle: { padding: "10px 10px 0px 28px" },
            field: "goal_subcategory",
            render: (rowData) => rowData?.goal_subcategory,
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.goal_subcategory?.trim()) {
                return "Goal cannot be empty";
              }
              return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "95%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
          
          
        ]}
        data={structureData || []}
        icons={{
          Add: () => (
            <Button
              variant="contained"
              className="mpl-primary-btn"
              style={{
                minWidth: 0,
                width: "82px",
                height: "35px",
                padding: "2px 12px",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          ),
          Edit: () => <EditIcon sx={{ color: "#637381" }} />,
          Delete: () => <DeleteIcon sx={{ color: "#637381" }} />,
        }}
        editable={{
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.goal_category_configuration_pk) {
                return reject();
              }
              if (!newRow?.goal_subcategory?.trim()) {
                return reject();
              }
              dispatch(
                AddGoalSubtypeAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.goal_category_configuration_pk) {
                return reject();
              }
              if (!newRow?.goal_subcategory?.trim()) {
                return reject();
              }
              dispatch(
                UpdateGoalSubtypeAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteGoalSubtypeAction({
                  ...selectedRow,
                  goal_subcategory_config_id: `{${selectedRow?.goal_sub_category_configuration_pk}}`,
                })
              );
              setTimeout(() => resolve(), 1000);
            }),
        }}
        options={{
          maxBodyHeight: "250px",
          minBodyHeight: "250px",
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "5px 10px 5px 25px", fontWeight: "bold" },
          sorting: false,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        components={{
          Action: (props) => {
            const ActionComponent = props?.components?.Action || MTableAction;

            if (
              props?.action?.icon &&
              typeof props?.action?.icon === "function"
            ) {
              return (
                <Box
                  sx={{
                    "& .MuiIconButton-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  <ActionComponent {...props} />
                </Box>
              );
            }
            return <ActionComponent {...props} />;
          },
        }}
        title={titleContent}
      />
      <ConfirmationDialog
          title="Do you wish to proceed?" // Are you sure you want to delete this expense type?
          content={<Box fontWeight={"500"}>
          All Goals under <Box as="span" fontWeight="bold" display="inline">
            {deletedItem?.goal_category_name}
          </Box>{" "} goal category will also be permanently deleted.
          </Box>}
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          OkButtonText="Yes"
          onSubmit={handleSubmitDelete}
      />
    </Box>
  );
};

export default GoalCategoryGrid;
